import React, {useState}  from "react";
import { Row, Col } from "react-bootstrap";
import AccountIdBox from "../../AccountIdBox";
import ConversionActionIds from "../../ConversionActionIds";
import CustomTooltip from "utils/CustomTooltip";
import ManualDataPull from "client_config/ManualDataPull";
import Inflation from "client_config/ppc_config/Inflation";
import CurrencySelector from "client_config/CurrencySelector";
import jsDig from "utils/jsDig.js"

export default function IdsData(props) {
  let thumbnail = require("images/ShowMeHow.jpg");
  thumbnail = <img className="thumbnail" src={`/datapulse${thumbnail}`} />;

  let example = require("images/onboarding/microsoft-example.png");
  example = <img className="pt-3" src={`/datapulse${example}`} />;

  let platforms = [
    {
      name: "google_ads",
      id: "pull-search-google",
      label: "Pull Google Ads on save"
    },
    {
      name: "microsoft_ads",
      id: "pull-search-microsoft",
      label: "Pull Microsoft Ads on save"
    },
  ];
  let platformNames = ["Google", "Microsoft"];

  const [baseCurrency, setBaseCurrency] = useState(props.search_section.base_currency)
  const [displayCurrency, setDisplayCurrency] = useState(props.search_section.display_currency)

  return (
    <div className="ml-0 ml-md-3 p-3">
      <Row className="py-4 px-0 px-md-4 justify-content-between">
        <Col xs={12} lg={6}>
          <div className="">
            <span className="text-info  visby-bold f-18">
              Account IDs
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="List your account IDs below for the specified platforms. This is how we will pull metrics into DataPulse, so it’s important that your IDs match exactly."
                inline={true}
              />
            </span>
            <div className="py-4">
              <AccountIdBox
                platformId="search-google-ads-id"
                platformName="Google Ads"
                platformData={jsDig(["google_ads"], props.search_section.platform_data)}
                fieldName="[platform_data][search][google_ads]"
              />
            </div>
            <div className="py-4">
              <AccountIdBox
                example = {example}
                platformId="search-microsoft-ads-id"
                platformName="Microsoft Ads"
                platformData={jsDig(["microsoft_ads"], props.search_section.platform_data)}
                fieldName="[platform_data][search][microsoft_ads]"
              />
            </div>
          </div>
          <div className="pt-4">
            <span className="text-info visby-bold f-18">
              Include/Exclude Conversion Action IDs
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message={
                  <div style={{ textAlign: "center" }}>
                    <p>To get a Conversion Action ID, go to Google Ads and open the Tools & Settings menu from the top right of the navbar. In the Measurement column, select Conversions. Next, select the conversion action from the list that appears. Once you have selected a conversion action, check the final URL of the page and look for the 'ctId' parameter. This will be equal to the Conversion Action's ID.</p>
                    <img src="https://digital-position.monday.com/protected_static/2205640/resources/991799417/large-conversion-action-ctid.jpg" alt="Conversion Aciton ID" style={{ maxWidth: "450px", display: "block", margin: "0 auto", marginTop: "10px" }}/>
                  </div>
                }
                inline={true}
              />
            </span>
            <div className="pt-4">
              <ConversionActionIds
                conversionActionsEnabled={props.search_section.conversion_actions_enabled}
                conversionActions={props.search_section.conversion_actions}
                fieldName="[conversion_actions][search]"
              />
            </div>
          </div>
        </Col>
        <Col className="px-0 px-md-3" xs={12} lg={6}>
          <ManualDataPull
            isEnabled={props.search_section.data_pull_enabled}
            platforms={platforms}
            service="search"
            handleSubmit={props.handleSubmit}
          />
        </Col>
      </Row>
      <Row className="py-4 px-0 px-md-4">
        <Col>
          <div className="py-4 center-it">
            <span className="text-info visby-bold f-18">
              Inflation (Past 30 Days)
            </span>
						<span style={{cursor:"pointer"}}>
						<CustomTooltip inline={true} delay={1700} faClass="pl-2 text-info far fa-question-circle"  message={<a href={"https://www.youtube.com/watch?v=B_BFhFnahjw"} target="_blank">{thumbnail}</a>} />
						</span>
            <div className="py-4">
              <Inflation daily_yields={props.search_section.daily_yields} platforms={platformNames} {...props} section={"search"} />

            </div>
          </div>
        </Col>
      </Row>
      <Row className="py-4 px-0 px-md-4">
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Base Currency</h5>
          <CurrencySelector selectedCurrency={baseCurrency} setSelectedCurrency={setBaseCurrency} nameAttribute="search_base_currency" />
        </Col>
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Display Currency</h5>
          <CurrencySelector selectedCurrency={displayCurrency} setSelectedCurrency={setDisplayCurrency} nameAttribute="search_display_currency" />
        </Col>
      </Row>
    </div>
  );
}
